import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Bot } from "lucide-react";
import { trackEvent } from "@/utils/analyticsTrack";

/**
 * Botão flutuante global do Guru Chat.
 * - Mobile: canto inferior ESQUERDO, acima do menu inferior (respeita safe-area).
 * - Desktop: canto inferior esquerdo.
 * - Visível para logados e visitantes (teaser).
 * - Oculto na própria rota /guru-chat.
 */
const GuruFloatingButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowTooltip(true), 1200);
    const t2 = setTimeout(() => setShowTooltip(false), 6000);
    return () => { clearTimeout(t); clearTimeout(t2); };
  }, []);

  if (location.pathname.startsWith("/guru-chat")) return null;

  const handleClick = () => {
    trackEvent("guru_chat_floating_click" as any, { from: location.pathname });
    navigate("/guru-chat#guru-chat-funcao");
  };

  return (
    <div
      className="fixed z-40 left-3 bottom-[calc(5rem+env(safe-area-inset-bottom))] md:bottom-6 flex flex-col items-center gap-1"
      aria-hidden={false}
    >
      {showTooltip && (
        <div className="absolute -top-10 left-0 whitespace-nowrap rounded-lg bg-zinc-900/95 px-3 py-1.5 text-xs font-semibold text-amber-300 shadow-lg border border-amber-500/30 animate-fade-in">
          🔮 Consultar o Guru
          <span className="absolute -bottom-1 left-4 w-2 h-2 rotate-45 bg-zinc-900 border-r border-b border-amber-500/30" />
        </div>
      )}
      <button
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Abrir Guru Chat"
        title="Consultar o Guru"
        className="group relative flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-purple-600 via-amber-500 to-yellow-500 text-zinc-900 shadow-[0_0_28px_-4px_rgba(168,85,247,0.7)] ring-2 ring-amber-300/50 hover:scale-105 active:scale-95 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-amber-400/30 animate-ping" />
        <Bot className="relative h-8 w-8" strokeWidth={2.4} />
        <span className="absolute -top-1 -right-1 bg-gradient-to-r from-yellow-300 to-amber-500 text-black text-[9px] font-extrabold px-1.5 py-0.5 rounded-full shadow border border-amber-700/30">
          IA
        </span>
      </button>
      <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-zinc-900/85 text-amber-300 border border-amber-500/30 shadow whitespace-nowrap">
        Guru Chat
      </span>
    </div>
  );
};

export default GuruFloatingButton;
